import { createContext } from 'react';

import { SelectedOwnerIndividualPermissionContextProps } from './SelectedOwnerIndividualPermissionContext.types';

export const SelectedOwnerIndividualPermissionContext = createContext<
  SelectedOwnerIndividualPermissionContextProps | undefined
>(undefined);
